import { useState, Fragment } from "react";
import Input from "../../input";
import { Listbox, Transition } from "@headlessui/react";
import { MdArrowDropDown } from "react-icons/md";

const banks = ["UBA", "GTB", "KUDA"];

export default function LinkAccount({ handleSteps }) {
  const [selectedBank, setSelectedBank] = useState(banks[0]);

  const verify = () => {
    handleSteps();
  };

  return (
    <div>
      <Listbox
        as="div"
        value={selectedBank}
        onChange={setSelectedBank}
        className="mb-6 bg-[#F7FAFF] px-4 py-2"
      >
        <span className="flex items-center justify-between">
            <Listbox.Button>{selectedBank}</Listbox.Button>
            <MdArrowDropDown />
        </span>
        <Transition
          as={Fragment}
          leave="transition ease-in duration-100"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <Listbox.Options>
            {banks.map((bank, i) => (
              <Listbox.Option key={i} value={bank} className="my-2">
                {bank}
              </Listbox.Option>
            ))}
          </Listbox.Options>
        </Transition>
      </Listbox>

      <Input
        type="number"
        className="mb-5"
        label="Account number"
        id="accountNumber"
        required
      />

      <Input type="text" label="Account name" id="accountName" required />

      <div className="mt-12 flex justify-end">
        <button
          className="bg-[#4285F4] text-base text-white font-bold px-6 py-2.5"
          onClick={verify}
        >
          Next
        </button>
      </div>
    </div>
  );
}
